var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 27,
    viewBox: "0 0 14 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fontisto:facebook",
    clipPath: "url(#clip0_666_5246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.927 1.02235V4.30242H8.97601C8.7174 4.26936 8.45471 4.29233 8.20577 4.36976C7.95683 4.4472 7.72746 4.57728 7.53323 4.75119L7.53495 4.74946C7.25574 5.14115 7.12395 5.61891 7.16284 6.09835V6.09146V8.43953H10.8055L10.3232 12.1175H7.16801V21.546H3.36338V12.1167H0.193573V8.43953H3.36338V5.73055C3.32217 5.07626 3.41574 4.42048 3.63828 3.80382C3.86082 3.18716 4.2076 2.62276 4.65714 2.14557L4.65456 2.14815C5.11339 1.71339 5.65576 1.37636 6.24876 1.15752C6.84177 0.938676 7.47305 0.842581 8.10431 0.875062H8.09311C9.07358 0.858889 10.054 0.912139 11.0269 1.03441L10.9261 1.02408L10.927 1.02235Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_5246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 26,
    fill: "white",
    transform: "translate(0.192505 0.874512)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f075b16848fe0825b07558bc550ed883.svg";
export { ForwardRef as ReactComponent };